"use strict";

/**
 * This callback type is called `requestCallback` and is displayed as a global symbol.
 *
 * @callback iterateeCallback
 * @param {*} Value
 * @param {string} Key
 * @param {object} Original object
 */
/**
 * Iterates over object values
 * @param {Object} collection
 * @param {iterateeCallback} iteratee
 * @return {Object} iterated object
 */
module.exports.mapValues = function (collection, iteratee) {
  if (!collection) {
    return {};
  }
  return Object.keys(collection).reduce(function (acc, key) {
    acc[key] = iteratee(collection[key], key, collection);
    return acc;
  }, {});
};
//# sourceMappingURL=collections.js.map


//////////////////
// WEBPACK FOOTER
// ../~/wix-bi-logger-client/dist/utils/collections.js
// module id = 316
// module chunks = 0 1